import { Injectable } from '@angular/core';
import { StageAdminService } from '@shared-angular/services/stage-admin.service';

export type SkillUsageStageHit = {
  stageId: string,
  title: string
};

@Injectable({
  providedIn: 'root'
})
export class SkillUsageService {

  constructor(
    private stageAdmin: StageAdminService
  ) { }

  public getUsage(skillId: string): SkillUsageStageHit[] {
    if (!skillId.trim()) {
      return [];
    }
    return this.stageAdmin.stages
      .filter((stage) => stage.skills.includes(skillId))
      .map((stage) => ({ stageId: stage._id, title: stage.title }));
  }
}
